import { Button, makeStyles } from "@material-ui/core";
import React from "react";
import styleVariables from "../../services/variables";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: styleVariables.primaryColor,
    color: "white",
    "&:hover": {
      backgroundColor: styleVariables.secondaryColor,
      color: "white",
    },
  },
}));

const SaveButton = (props) => {
  const classes = useStyles();

  return (
    <Button
      className={classes.root}
      type="submit"
      fullWidth
      variant="contained"
      {...props}
    >
      {props.label ? props.label : "Save"}
    </Button>
  );
};

export default SaveButton;
